import { atom } from 'recoil';

// Simple notification atom: { message, description } or null.
const alertAtom = atom({
    key: 'alert',
    default: { message: null, description: null },
});

export { alertAtom };
